export type DropDownColor = Color.PRIMARY | Color.SECONDARY;

export enum Color {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}
